// extracted by mini-css-extract-plugin
export var chevronIcon = "_9l-2";
export var teamName = "_9l-1";
export var teamSwitcherButton = "_9l-0";